//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from '../api/api.models'

import { BaseGridController, ScopeBaseGrid } from '../common/common.base.grid.controller'
import { ButtonsOptions } from '../common/grid/grid.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from '../common/details-popup/details-popup.directive'
import { GridTypes, GridController } from '../common/grid/grid.controller'
import { LoggerService } from './../common/common.module'
import { i18n } from '../common/i18n/common.i18n'

import { CommonHelper } from '../../helpers/common-helper'
import { EventsNames } from '../../helpers/events-names'
import { LocalizationHelper } from '../../helpers/localization-helper'
import { IssueHelper } from './issues.helper'

import { Enums } from '../../models/common/enums'
import { Activity } from '../../models/common/activity'
import { OpIssue } from '../../models/core/op-issue'
import { ImportOptions } from '../common/import/import.directive';

import { SystemService } from '../../services/system'
import { UserSessionService } from '../../services/user-session'
import { GridContextMenuService } from '../../services/grid'

export interface IssuesScope extends ScopeBaseGrid {
    creationDate: Date

    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }
}

export class IssuesController extends BaseGridController {

    // Members

    private grid: GridController<OpIssue>

    // Members End

    constructor(
        protected $scope: IssuesScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        private gridContextMenuService: GridContextMenuService,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, referenctType)

        this.setConfirmationsOptions()
        this.setEvents()
        this.setMainGridOptions()
    }

    // Events 

    private onInitialized(e: any, grid: GridController<OpIssue>): void {
        this.grid = grid
        this.dataGrid = e.component

        this.setGridId(e.tableId)
    }

    private onAdd(): void {
        const createAddInitParams: CreateEditInitParams = IssueHelper.getCreateEditOptions()

        this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createAddInitParams)
    }

    private onEdit(): void {
        if (this.dataGrid.getSelectedRowKeys().length == 1) {
            const createEditInitParams: CreateEditInitParams = IssueHelper.getCreateEditOptions(this.grid.selectedItemId)

            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        } else {
            const columnCount: number = this.dataGrid.columnCount()
            const columns: any[] = []

            for (let i = 0; i < columnCount; i++) {
                columns.push(this.dataGrid.columnOption(i));
            }

            const bulkEditInitParams: BulkEditInitParams = {
                gridColumns: columns,
                groupReferenceType: null,
                groupReferenceValue: null,
                idReferenceType: this.referenceType,
                moduleName: this.moduleName,
                section: null,
                selectedGridRows: angular.copy(this.grid.selectedGridItems),
                useBusinessObjects: true
            }
            // Potrzebne do odczytania CREATION_DATE z OpIssue dla masowej edycji.
            bulkEditInitParams['__issues_bulk_edit_data__'] = this.grid.selectedItems

            this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onShowDetails(e: any): void {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId
        }
        this.showDetails(e, detailsOptions)
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onDeleted(): void {
        this.grid.dxGrid.refresh()
    }

    private onConfirmDelete(): void {
        IssueHelper
            .deleteIssue(this.userSession.getDataProvider(), this.grid.selectedItem, this.moduleName)
            .then((result: OpIssue) => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    // Events End

    // Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItemsByReferenceType(Enums.ReferenceType.IdIssue, {
            idReferenceTypes: this.grid.selectedItemsIds,
            onEdit: () => this.onEdit(),
        })

        return this.mergeWithDefaultItems(isTouchScreen, items)
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_ADD) ? "['" + Activity[Activity.ISSUE_ADD] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DEL) ? "['" + Activity[Activity.ISSUE_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_EDIT) ? "['" + Activity[Activity.ISSUE_EDIT] + "']" : null,
            exportPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_EXPORT_OP) ? "['" + Activity[Activity.ISSUE_EXPORT_OP] + "']" : null,
            importPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_IMPORT_OP) ? "['" + Activity[Activity.ISSUE_IMPORT_OP] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            taskMultiplePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_MULTIPLE_ADD) ? "['" + Activity[Activity.TASK_MULTIPLE_ADD] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_LIST) ? "['" + Activity[Activity.ISSUE_LIST] + "']" : null,

            onAddClick: () => this.onAdd(),
            onDeleteClick: () => this.onDelete(),
            onEditClick: () => this.onEdit(),
            onShowClick: (e: any) => this.onShowDetails(e),
            addIssueMultiple: true,
            addTaskMultiple: true
        }
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted()
        )

        this.$scope.$on(
            EventsNames.OPEN_LOCATION_CREATE_ISSUES_TASKS_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
                if (this.grid.selectedItems != null) {
                    for (let i = 0; i < this.grid.selectedItems.length; i++) {
                        args[1][i].idLocation = this.grid.selectedItems[i].idLocation
                        args[1][i].id = this.grid.selectedItems[i].idIssue
                    }
                    this.$scope.$root.$broadcast(IssueHelper.ISSUES_OPEN_CREATE_ISSUE_TASK, ...args)
                }
            })

        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private getImportOptions(): ImportOptions {
        return {
            dictionaryMethodName: 'getIssueImportParams',
            popupName: i18n('Popup', 'ImportIssues'),
            requestMethodType: 'issue',
            referenceType: Enums.ReferenceType.IdIssue,
            moduleName: Enums.SimaxModuleName.Issue,
            columnsReorderingDisabled: false
        }
    }

    private setMainGridOptions(): void {
        $.when(
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName),
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName)
        ).then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
            this.$scope.mainGridOptions = {
                referenceId: this.referenceType,
                idReferenceType: this.referenceType,
                type: GridTypes.MAIN,
                name: 'IssueGrid',
                addCustomFilters: true,
                buttonsOptions: this.getGridButtonsOptions(),
                columnsDictionary: columns,
                dataSourceAdditionalFields: null,
                defaultColumnsDictionary: defaultColumns,
                localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.issueSaved,
                preExecuteClearFilter: this.preExecuteGridClearFilter,
                importOptions: this.getImportOptions(),
                allowColumnReordering: !this.userSession
                    .getLoggedOperator()
                    .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueModuleMainGrid),

                getDataSourceMethod: this.userSession
                    .getDataProvider().Issue.getIssueFilter,

                onInitialized: (e: any, grid: GridController<OpIssue>) => this.onInitialized(e, grid),
                onDataReady: (data: any) => this.onDataReady(data),
                onRowDoubleClick: (e: any) => this.onShowDetails(e),
                contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
            }
        })
    }
}
